module.exports = __webpack_public_path__ + "img/consult_info1.d4381a5e.png";